import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const DashboardPage = lazy(() =>
  import("@/admin/pages/DashboardPage").then((m) => ({ default: m.DashboardPage })),
);

export const Route = createFileRoute("/admin/")({
  component: () => (
    <Suspense fallback={null}>
      <DashboardPage />
    </Suspense>
  ),
});
